import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

export enum FieldIssueTypeEnum {
  error = 'error',
  warning = 'warning',
}

@ObjectType()
@InputType('FieldIssueInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class FieldIssue {
  @Field(() => ID)
  @Prop({ type: String, default: () => generateEntityId('fldi') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  type: FieldIssueTypeEnum

  @Field(() => String)
  @Prop({ type: String })
  message: string

  @Field(() => String)
  @Prop({ type: String })
  stackTrace: string

  @Field(() => String)
  @Prop({ type: String })
  fieldName: string
}
